import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { QuoteDisplay } from './QuoteDisplay';
import { UnlockQuote } from './UnlockQuote';
import { QuoteEstimatePopup } from './QuoteEstimatePopup';





export function BasePopup({ show, bodyParts, onHide }) {


  const [value, setValue] = useState(1);
  const [injury, setInjury] = useState("");
  const [showQuote, setShowQuote] = useState(false);
  const [leadId, setLeadId] = useState(null);

  function onClose() {
    setInjury("");
    setValue(1);
    onHide();
  }

  return (
    <>
    {
        showQuote ?
        <QuoteEstimatePopup show={show} bodyParts={bodyParts} leadId={leadId} onHide={onHide} /> :
        <UnlockQuote show={show} onHide={onHide} setShowQuote={setShowQuote} bodyParts={bodyParts} setLeadId={setLeadId} />
    }
    </>
  );
}